import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';

// Initialize Firebase
const app = initializeApp({
  // Your web app's Firebase configuration
  apiKey: "AIzaSyBqIIr2bprKAMP6QEzy0U0Q7ND9T0PYN2o",
  authDomain: "therapist-online.firebaseapp.com",
  projectId: "therapist-online",
  storageBucket: "therapist-online.firebasestorage.app",
  messagingSenderId: "383278496429",
  appId: "1:383278496429:web:c0ff8e6596ee700268e424"
});

const auth = getAuth(app);
const db = getFirestore(app);

// Local emulators are opt-in. Production is the default, so a deployed build
// cannot silently redirect its Firebase traffic to a developer machine.
if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
  const emulatorHost = process.env.REACT_APP_FIREBASE_EMULATOR_HOST || '127.0.0.1';

  connectAuthEmulator(auth, `http://${emulatorHost}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(db, emulatorHost, 8080);
}

export { auth, db };
